import { all, fork } from 'redux-saga/effects';
import { watchCreatePersonalTaskSaga } from './create-personal-task';
import { watchDeletePersonalTasksSaga } from './delete-personal-task';
import { watchFetchPersonalTasksSaga } from './fetch-personal-tasks';
import { watchUpdatePersonalTasksSaga } from './update-personal-tasks';

export function* personalTasksRootSaga() {
  yield all([
    fork(watchUpdatePersonalTasksSaga),
    fork(watchCreatePersonalTaskSaga),
    fork(watchDeletePersonalTasksSaga),
    fork(watchFetchPersonalTasksSaga),
  ]);
}
